module.exports = __webpack_public_path__ + "images/e31081c665093d3d1bbed060cd78edbd.jpg";